import { ActionType } from '../ActionsTypes';
import { ReducerAction } from '../ReducerAction';
export class UIActions {
    static openDepositAccounts(): ReducerAction {
        return {
            type: ActionType.UI_OPEN_DEPOSIT_ACCOUNTS
        }
    }
    static closeDepositAccounts(): ReducerAction {
        return {
            type: ActionType.UI_CLOSE_DEPOSIT_ACCOUNTS
        }
    }
    static openCommissions(): ReducerAction {
        return {
            type: ActionType.UI_OPEN_COMMISSIONS
        };
    }
    static closeCommissions(): ReducerAction {
        return {
            type: ActionType.UI_CLOSE_COMMISSIONS
        }
    }

    static showBalance(): ReducerAction {
        return {
            type: ActionType.UI_SHOW_BALANCE
        }
    }

    static hideBalance(): ReducerAction {
        return {
            type: ActionType.UI_HIDE_BALANCE
        }
    }

    static openTwoFactorAuthentication(): ReducerAction {
        return {
            type: ActionType.UI_OPEN_TWOFACTOR
        }
    }

    static closeTwoFactorAuthentication(): ReducerAction {
        return {
            type: ActionType.UI_CLOSE_TWOFACTOR
        }
    }

    static closeChangePassword(): ReducerAction {
        return {
            type: ActionType.UI_CLOSE_PASSWORD
        }
    }
    static openChangePassword(): ReducerAction {
        return {
            type: ActionType.UI_OPEN_PASSWORD
        }
    }

    static openSessionTime(): ReducerAction {
        return {
            type: ActionType.UI_OPEN_SESSION_TIME
        }
    }

    static closeSessionTime(): ReducerAction {
        return {
            type: ActionType.UI_CLOSE_SESSION_TIME
        }
    }

    static openModalMov(): ReducerAction {
        return {
            type: ActionType.UI_OPEN_MODAL_MOV
        }
    }

    static closeModalMov(): ReducerAction {
        return {
            type: ActionType.UI_CLOSE_MODAL_MOV
        }
    }

    static setLoaginCheckLoading(isLoading: boolean): ReducerAction {
        return {
            type: ActionType.UI_SET_LOGIN_CHECK_LOADING,
            payload: isLoading
        }
    }

    static openModalHelp(): ReducerAction {
        return {
            type: ActionType.UI_OPEN_MODAL_HELP
        }
    }

    static closeModalHelp(): ReducerAction {
        return {
            type: ActionType.UI_CLOSE_MODAL_HELP
        }
    }

    //Loading screen
    static uiLoadActive(): ReducerAction {
        return {
            type: ActionType.LOADING_ACTIVE
        }
    }

    static uiLoadInactive(): ReducerAction {
        return {
            type: ActionType.LOADING_INACTIVE
        }
    }
}